// Profile
import UserProfile from "../pages/Authentication/user-profile"

// Authentication related pages
import Login from "../pages/Authentication/Login"
import Logout from "../pages/Authentication/Logout"
import Register from "../pages/Authentication/Register"
import ForgetPwd from "../pages/Authentication/ForgetPassword"
import Plastics from "../pages/PlasticsAuthorization"
import PlasticsApply from "../pages/PlasticsAuthorization/Apply"
import Disposal from "../pages/ProductDisposal"
import DisposalApply from "../pages/ProductDisposal/Apply"
import EditLicenseApplication from "pages/Licensing/Common/EditApplication"

// 2024 pages
import NominationLetterAccreditation from "../pages/NominationLetterAccreditation"
import NominationLetterApply from "../pages/NominationLetterAccreditation/NominationLetterApply"
import NoObjectionLetter from "../pages/NoObjectionLetter"
import NoObjectionLetterApply from "pages/NoObjectionLetter/NoObjectionLetterApply"
import DeliveryPartner from "pages/DeliveryPartner"
import DeliveryPartnerApply from "pages/DeliveryPartner/DeliveryPartnerApply"
import EnvironmentalAudit from "pages/EnvironmentalAudit"
import EnvironmentalAuditApply from "pages/EnvironmentalAudit/EnvironmentalAuditApply"

// Dashboard
import Dashboard from "../pages/Dashboard/index"

// Services
import Services from "pages/Services/index"

// Licensing
import ExportInfo from "pages/Licensing/Exports"
import ImportInfo from "pages/Licensing/Imports"
import ViewExport from "pages/ViewFiles/Licensing/Export/"

import ImportApply from "pages/Licensing/Imports/ImportApply"
import ExportApply from "pages/Licensing/Exports/ExportApply"

// Companies
import Companies from "pages/Companies/index"
import PlasticsRecycled from "pages/Recycle/PlasticsRecycled"

// Dashboard Menus
import EnvAuditMenu from "pages/Dashboard/EnvAuditMenu"


const userRoutes = [
  { path: "/dashboard", component: Dashboard },

  { path: "/services", component: Services },

  { path: "/companies", component: Companies },

  { path: "/auth-plastics", component: Plastics },

  { path: "/guidance-disposal", component: Disposal },

  { path: "/product-disposal-apply", component: DisposalApply },

  { path: "/auth-plastics-apply", component: PlasticsApply },

  { path: "/view-application", component: PlasticsApply },
  { path: "/view-application-disposal", component: DisposalApply },
  { path: "/plastics-recycled", component: PlasticsRecycled },

  // Licensing
  { path: "/licensing-export", component: ExportInfo },
  { path: "/licensing-import", component: ImportInfo },
  { path: "/licensing-import-apply", component: ImportApply },
  { path: "/licensing-export-apply", component: ExportApply },
  { path: "/view-application-export", component: ViewExport },
  { path: "/edit-license-application", component: EditLicenseApplication },

  // // //profile
  { path: "/profile", component: UserProfile },

  // 2024 services
  { path: "/nomination-letter-accreditation", component: NominationLetterAccreditation },
  { path: "/nomination-letter-accreditation-apply", component: NominationLetterApply },
  { path: "/view-application-nomination-letter-accreditation", component: NominationLetterApply },
  { path: "/no-objection-letter", component: NoObjectionLetter },
  { path: "/view-application-no-objection-letter", component: NoObjectionLetterApply },
  { path: "/no-objection-letter-apply", component: NoObjectionLetterApply },
  { path: "/delivery-partner", component: DeliveryPartner },
  { path: "/delivery-partner-apply", component: DeliveryPartnerApply },
  { path: "/view-application-delivery-partner", component: DeliveryPartnerApply },
  { path: "/environmental-audit", component: EnvironmentalAudit },
  { path: "/environmental-audit-apply", component: EnvironmentalAuditApply },
  { path: "/view-application-environmental-audit", component: EnvironmentalAuditApply },


  // Dashboard Menus
  { path: "/env-audit-menu", component: EnvAuditMenu },
]

const authRoutes = [
  { path: "/logout", component: Logout },
  { path: "/login", component: Login },
  { path: "/forgot-password", component: ForgetPwd },
  { path: "/register", component: Register },
]

export { userRoutes, authRoutes }
